export default __webpack_public_path__ + "static/media/logo192.81a0558a.png";